import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../app-context';
import IGridComponent from '../../../components/grid/i-grid.component';
import TitlePanel from '../../../components/title-panel/title-panel.component';
import { DAYS_QTR, PAGE_SIZE } from '../../common/constants';
import { formatDate, formatDateSmall, formatDateTrn, formatTime, formatTo0Decimal, formatTo1Decimal, formatTo2Decimal, isEmpty, isEmptyArray, isNotEmpty } from '../../common/util.services';
import { getPerformance, syncOrder, syncSale, syncTransactionAPI, syncPerf, syncPerfZeroValue, savePerfData, getPerfParam, getLatestTime, getOrderCountTrend, getOrderValueTrend, getUnitTrend, syncAll, getAdSpendTrend} from '../amazon.services';
import { FormControl, FormControlLabel, Grid, Radio, RadioGroup, Stack, useMediaQuery, useTheme } from '@mui/material';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import '../amazon.scss';
import IButton from '../../../components/button/i-button.component';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { AssessmentOutlined, Launch, PlayCircleOutline } from '@mui/icons-material';
import YesNoDialog from '../../../components/message-dialog/yes-no-dialog.component';
import { useNavigate } from 'react-router-dom';
import IDialogComponent from '../../../components/dialog/i-dialog.component';
import EditCellComponent from '../../costing/detail/edit-cell.component';
import IReadOnlyField from '../../../components/text-component/readonly-field/i-readonlyfield.component';
import { Box, Tooltip } from '@mui/material';
import LineChart from '../order/line-chart.component';

const AmazonOrderPerf = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const appContext = useContext(AppContext);
  const navigate = useNavigate();
  const rows: GridRowsProp = [];
  const [perfData, setPerfData] = useState(rows);
  dayjs.extend(utc);
  dayjs.extend(timezone);
  let today = dayjs();
  let sDate = today.subtract(DAYS_QTR, 'day');
  const [startDate, setStartDate] = useState<any>(sDate);
  const [endDate, setEndDate] = useState<any>(today);
  const [showSyncMsg, setShowSyncMsg] = useState(false);
  const [openChart, setOpenChart] = useState(false);
  const [orderCountTrendData, setOrderCountTrendData] = useState<any>([]);
  const [orderValueTrendData, setOrderValueTrendData] = useState<any>([]);
  const [cumulativeTrendData, setCumulativeTrendData] = useState<any>([]);
  const [asinUnitTrendData, setAsinUnitTrendData] = useState<any>([]);
  const [totalUnitTrendData, setTotalUnitTrendData] = useState<any>([]);
  const [adSepndData, setAdSpendData] = useState<any>([]);
  const [syncType, setSyncType] = useState('');
  const [orderDate, setOrderDate] = useState('');
  const [cellLabel, setCellLabel] = useState('');
  const [cellValueRow, setCellValueRow] = useState<any>([]);
  const [perfParam, setPerfParam] = useState<any>()
  const [openValue, setOpenValue] = useState(false);
  const [latestOrderTime, setLatestOrderTime] = useState('');
  const [period, setPeriod] = useState('DailyOrder');
  const popperProps = {sx: {'.MuiTooltip-tooltip': {bgcolor: 'ivory', fontSize: 16, color: 'black', border: 1}}};
  const columnsSync: GridColDef[] = [
    { field: 'syncAll', headerName: 'Sync', filterable: false, sortable: false, editable: false, width: 50,
      renderCell: (params) => (<Stack direction="row" alignItems="center" justifyContent="center" sx={{ height: '100%' }}> 
                               <PlayCircleOutline fontSize='small' color="secondary"/></Stack>)
    },
    { field: 'latestOrderTime', headerName: 'Latest Order', filterable: false, sortable: false, editable: false, width: 110,
      valueFormatter: (latestOrderDate: any) => formatTime(latestOrderDate)
    },
    { field: 'latestTrnTime', headerName: 'Latest Trn', filterable: false, sortable: false, editable: false, width: 110,
      valueFormatter: (latestTrnTime: any) => formatTime(latestTrnTime)
    }
  ];
  const columnsPerf: GridColDef[] = [
    { field: 'period', headerName: 'Period', filterable: false, sortable: false, editable: false, width: 120,
      cellClassName: (params) => { return "Tacos2"},
      renderCell: (params) => (<Stack direction="row" alignItems="center" gap={1}> 
                                {'DailyOrder' === period && <Launch fontSize='small' color="primary"/>}
                                {'DailyOrder' === period ? formatDate(params.row.orderDate) : params.row.period}
                               </Stack>)
    },
    { field: 'grossProfit', headerName: 'Gross', filterable: false, sortable: false, editable: false, width: 65,
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePerf(params.row.grossProfit) }
    },
    { field: 'grossOnSale', headerName: 'Gross/Ord', filterable: false, sortable: false, editable: false, width: 85,
      valueFormatter: (value: any) => 'NA' === getValue1Decimal(value) ? 'NA' : getValue1Decimal(value) + '%',
      cellClassName: (params) => { return getClassNamePerf(params.row.grossOnSale) }
    },
    { field: 'netProfit', headerName: 'Net', filterable: false, sortable: false, editable: false, width: 65,
      renderCell: (params: any) =>  (<Tooltip title={'Daily: ' + getValue0Decimal(params.row.dailyNet)}
      PopperProps={popperProps}>{<Box>{getValue0Decimal(params.row.netProfit)}</Box>}</Tooltip>),
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePerf(params.row.netProfit) }
    },
    { field: 'netOnSale', headerName: 'Net/Ord', filterable: false, sortable: false, editable: false, width: 80,
      valueFormatter: (value: any) => 'NA' === getValue1Decimal(value) ? 'NA' : getValue1Decimal(value) + '%',
      cellClassName: (params) => { return getClassNamePerf(params.row.netOnSale) }
    },
    { field: 'netOnLfhCost', headerName: 'Net/LFH', filterable: false, sortable: false, editable: false, width: 85,
      valueFormatter: (value: any) => 'NA' === getValue1Decimal(value) ? 'NA' : getValue1Decimal(value) + '%',
      cellClassName: (params) => { return getClassNamePerf(params.row.netOnLfhCost) }
    },
    { field: 'acos', headerName: 'ACOS', filterable: false, sortable: false, editable: false, width: 65,
      cellClassName: (params) => { return getClassNameAcos(params.row.acos) },
      valueFormatter: (value: any) => 'NA' === getValue1Decimal(value) ? 'NA' : getValue1Decimal(value) + '%'
    },
    { field: 'tacos', headerName: 'TACOS', filterable: false, sortable: false, editable: false, width: 65,
      cellClassName: (params) => { return getClassNameTacos(params.row.tacos) },
      valueFormatter: (value: any) => 'NA' === getValue1Decimal(value) ? 'NA' : getValue1Decimal(value) + '%'
    },
    { field: 'adSpend', headerName: 'Ads', filterable: false, sortable: false, editable: false, width: 65,
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'adSpendAdj', headerName: 'Ads (A)', filterable: false, sortable: false, editable: false, width: 65,
      renderCell: (params: any) =>  (<Tooltip title={'Daily: ' + getValue0Decimal(params.row.dailyAd)}
      PopperProps={popperProps}>{<Box>{getValue0Decimal(params.row.adSpendAdj)}</Box>}</Tooltip>),
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'orderVal', headerName: 'Order', filterable: false, sortable: false, editable: false, width: 100,
      renderCell: (params) => (<Stack direction="row" alignItems="center" gap={1}>
                               <AssessmentOutlined fontSize='small' color="primary"/>
                               <Tooltip title={'Daily: ' + getValue0Decimal(params.row.dailyOrd)}
      PopperProps={popperProps}>{<Box>{getValue0Decimal(params.row.orderVal)}</Box>}</Tooltip></Stack>),
      cellClassName: (params) => { return getClassNamePerf(params.row.orderVal) }
    },
    { field: 'returnRate', headerName: 'Return', filterable: false, sortable: false, editable: false, width: 65,
      valueFormatter: (value: any) => formatTo1Decimal(value * 100) + '%',
    },
    { field: 'orderReturn', headerName: 'Ret Ord', filterable: false, sortable: false, editable: false, width: 70,
      renderCell: (params: any) =>  (<Tooltip title={'Daily: ' + getValue0Decimal(params.row.dailyRetOrd)}
      PopperProps={popperProps}>{<Box>{getValue0Decimal(params.row.orderReturn)}</Box>}</Tooltip>),
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePerf(params.row.orderReturn) }
    },
    { field: 'ctr', headerName: 'CTR', filterable: false, sortable: false, editable: false, width: 65,
      valueFormatter: (value: any) => 'NA' === getValue2Decimal(value) ? 'NA' : getValue2Decimal(value) + '%',
    },
    { field: 'click', headerName: 'Click', filterable: false, sortable: false, editable: false, width: 65,
      valueFormatter: (value: any) => formatTo0Decimal(value * 1)
    },
    { field: 'cpc', headerName: 'CPC', filterable: false, sortable: false, editable: false, width: 65,
      valueFormatter: (value: any) => formatTo2Decimal(value * 1)
    },
    { field: 'orderCount', headerName: 'Ord #', filterable: false, sortable: false, editable: false, width: 60,
      valueFormatter: (value: any) => formatTo0Decimal(value * 1)
    },
    { field: 'orderAsinUnit', headerName: 'ASIN #', filterable: false, sortable: false, editable: false, width: 65,
      valueFormatter: (value: any) => formatTo0Decimal(value * 1)
    },
    { field: 'orderUnit', headerName: 'Total #', filterable: false, sortable: false, editable: false, width: 70,
      valueFormatter: (value: any) => formatTo0Decimal(value * 1)
    },
    { field: 'amzFee', headerName: 'Fulfill+Refer', filterable: false, sortable: false, editable: false, width: 100,
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'otherAmzFee', headerName: 'Oth Amz', filterable: false, sortable: false, editable: false, width: 75,
      cellClassName: () => { return "PerfNegative"},
      renderCell: (params: any) =>  (<Tooltip title={getTooltipOthAmz(params.row)}
      PopperProps={popperProps}>{<Box>{getValue0Decimal(params.row.otherAmzFee)}</Box>}</Tooltip>)
    },
    { field: 'totalFee', headerName: 'Total Fee', filterable: false, sortable: false, editable: false, width: 80,
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'misc', headerName: 'Misc', filterable: false, sortable: false, editable: false, width: 60,
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'lfhCost', headerName: 'LFH Cost', filterable: false, sortable: false, editable: false, width: 80,
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'lfhAdj', headerName: 'LFH Adj', filterable: false, sortable: false, editable: false, width: 70,
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'xneetiFee', headerName: 'Xneeti', filterable: false, sortable: false, editable: false, width: 65,
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'otherGain', headerName: 'Oth Gain', filterable: false, sortable: false, editable: false, width: 75,
      valueFormatter: (value: any) => getValue0Decimal(value)
    },
    { field: 'amzFeePct', headerName: 'Fulfill+Refer', filterable: false, sortable: false, editable: false, width: 100,
      valueFormatter: (value: any) => 'NA' === getValue1Decimal(value) ? 'NA' : getValue1Decimal(value) + '%'
    },
    { field: 'otherAmzFeePct', headerName: 'Oth Amz', filterable: false, sortable: false, editable: false, width: 75,
      valueFormatter: (value: any) => 'NA' === getValue1Decimal(value) ? 'NA' : getValue1Decimal(value) + '%'
    },
    { field: 'lfhCostPct', headerName: 'LFH Cost', filterable: false, sortable: false, editable: false, width: 80,
      valueFormatter: (value: any) => 'NA' === getValue1Decimal(value) ? 'NA' : getValue1Decimal(value) + '%'
    },
    { field: 'adCostPct', headerName: 'Ad Cost', filterable: false, sortable: false, editable: false, width: 70,
      valueFormatter: (value: any) => 'NA' === getValue1Decimal(value) ? 'NA' : getValue1Decimal(value) + '%'
    },
    { field: 'xneetiPct', headerName: 'Xneeti', filterable: false, sortable: false, editable: false, width: 65,
      valueFormatter: (value: any) => 'NA' === getValue1Decimal(value) ? 'NA' : getValue1Decimal(value) + '%'
    },
    { field: 'totalCostPct', headerName: 'Total', filterable: false, sortable: false, editable: false, width: 75,
      valueFormatter: (value: any) => 'NA' === getValue1Decimal(value) ? 'NA' : getValue1Decimal(value) + '%'
    }
  ];
  const columns: GridColDef[] = 'DailyOrder' === period ? [...columnsSync, ...columnsPerf] : [...columnsPerf];
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [totalRows, setTotalRows] = useState(0);

  useEffect(() => {
    getOrderData();
    getPerfParamData();
  }, [period, startDate, endDate, page, pageSize]);

  function getLatestOrdTrnTime() {
    setLoading(true);
    getLatestTime(appContext,
      (response: any) => {
        setLatestOrderTime(response.data);
        appContext.setShowLoader(false);
        setLoading(false);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
        setLoading(false);
      });
  };

  function getOrderData() {
    if (isEmptyArray(rows)) {
      setLoading(true);
      let data = {startDate: startDate, endDate: endDate, period: period};
      getPerformance(data, page, pageSize, appContext,
        (response: any) => {
          setPerfData(response.data.content);
          setTotalRows(response.data.totalElements);
          getLatestOrdTrnTime();
          appContext.setShowLoader(false);
          setLoading(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
          setLoading(false);
        });
    }
  }

  function getTooltipOthAmz (row: any) {
    let storage = row.storage + row.longStorage;
    let awd = row.awdStorage + row.awdProcessing + row.awdTransportation;
    let promotion = row.priceDiscount + row.vine + row.deal + row.coupon;
    let invReimburse = +row.invReimburse;
    let other = row.totalFee - row.amzFee - storage - awd - promotion - invReimburse;

    let text = storage + ',' + awd + ',' + promotion + ',' + invReimburse + ',' + other;
    let array = text.split(',');
    array[0] = 'FBA Storage: ' + formatTo0Decimal(array[0]);
    array[1] = 'AWD: ' + formatTo0Decimal(array[1]);
    array[2] = 'Promotion: ' + formatTo0Decimal(array[2]);
    array[3] = 'Inv Reimburse: ' + formatTo0Decimal(array[3]);
    array[4] = 'Other: ' + formatTo0Decimal(array[4]);

    let newText = array.map(i => {
      return <p>{i}</p>
    });

    return newText;
  }

  function getPerfParamData() {
    setLoading(true);
    let data = {startDate: startDate, endDate: endDate, period: 'TotalOrder'};
    getPerfParam(data, appContext,
      (response: any) => {
        setPerfParam(response.data);
        appContext.setShowLoader(false);
        setLoading(false);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
        setLoading(false);
      });
  };

  const onPaginationModelChange = (evt: any) => {
    setPage(evt.page);
    setPageSize(evt.pageSize);
  }

  function getClassNamePerf(value: any) {
    return isEmpty(value) ? '' : value <= 0 ? "PerfNegative" : "PerfPositive";
  }

  function getClassNameTacos(value: any) {
    return isEmpty(value) ? '' : value > 20 ? "PerfNegative" : "PerfPositive";
  }

  function getClassNameAcos(value: any) {
    return isEmpty(value) ? '' : value > 35 ? "PerfNegative" : "PerfPositive";
  }

  const getValue0Decimal = (value: any) => {
    return isEmpty(value) ? 'NA' : formatTo0Decimal(value * 1);
  }

  const getValue1Decimal = (value: any) => {
    return isEmpty(value) ? 'NA' : formatTo1Decimal(value * 1);
  }

  const getValue2Decimal = (value: any) => {
    return isEmpty(value) ? 'NA' : formatTo2Decimal(value * 1);
  }

  const search = (e: any) => {
    getOrderData();
  }

  const startDatechange = (value: any) => {
    setStartDate(value);
  }

  const endDatechange = (value: any) => {
    setEndDate(value);
  }

  function checkRowId(rowId: any) {
    if(isEmpty(rowId)) {
      appContext.setDialogMessage('Sync performance data first.');
      return false;
    }
    return true;
  }
  
  const onCellDoubleClick = (value: any) => {
    if('DailyOrder' === period) {
      const field = value.field;
      if('adSpend' === field && checkRowId(value.row.rowId)) {
        setCellValueRow(value.row);
        setCellLabel('Ad Spend');
        openValuePopup();
      } else if('click' === field && checkRowId(value.row.rowId)) {
        setCellValueRow(value.row);
        setCellLabel('Click');
        //openValuePopup();
      } else if('ctr' === field && checkRowId(value.row.rowId)) {
        setCellValueRow(value.row);
        setCellLabel('CTR');
        //openValuePopup();
      }
    }
  }

  const openValuePopup = () => {
    setOpenValue(true);
  }

  const closeValuePopup = (value: any) => {
    if('Ok' === value) {
      setLoading(true);
      appContext.setShowLoader(true);
      savePerfData(cellValueRow, appContext,
        (response: any) => {
          appContext.setSuccessMessage(response.message)
          appContext.setShowLoader(false);
          setLoading(false);
          setOpenValue(false);
          getOrderData();
          getPerfParamData();
        }, (error: any) => {
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message)
          setLoading(false);
          setOpenValue(false);
      });
    } else {
      setOpenValue(false);
    }
  }

  const onCellClick = (value: any) => {
    const field = value.field;
    setOrderDate(value.row.idDate);
    if('syncAll' === field) {
      setSyncType('All');
      setShowSyncMsg(true);
    } else if('syncOrder' === field) {
      setSyncType('Order');
      setShowSyncMsg(true);
    } else if('syncSale' === field) {
      setSyncType('Sale');
      setShowSyncMsg(true);
    } else if('syncTrn' === field) {
      setSyncType('Trn');
      setShowSyncMsg(true);
    } else if('syncPerf' === field) {
      setSyncType('Perf');
      setShowSyncMsg(true);
    } else if('period' === field && !isMobile && 'DailyOrder' === period && !isEmpty(value.row.latestOrderTime)) {
      navigate('/amazon/allorder', {state: {orderDate: value.row.idDate}})
    } else if('orderVal' === field && !isMobile && isNotEmpty(value.row.orderVal)) {
      openOrderChart(value.row.orderDate);
    } else if('adSpend' === field && isMobile && checkRowId(value.row.rowId)) {
      setCellValueRow(value.row);
      setCellLabel('Ad Spend');
      openValuePopup();
    }
  }

  const openOrderChart = (value: any) => {
    let date = isEmpty(value) ? 'ALL' : formatDateTrn(value);
    setOrderDate(date);
    setLoading(true);
    getOrderCountTrend(date, appContext,
      (response: any) => {
        setOrderCountTrendData(response.data);
        appContext.setShowLoader(false);
        setLoading(false);
        setOpenChart(true);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
        setLoading(false);
      });

    getOrderValueTrend(date, 'Value', appContext,
      (response: any) => {
        setOrderValueTrendData(response.data);
        appContext.setShowLoader(false);
        setLoading(false);
        setOpenChart(true);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
        setLoading(false);
      });
    
    getOrderValueTrend(date, 'Cumulative', appContext,
      (response: any) => {
        setCumulativeTrendData(response.data);
        appContext.setShowLoader(false);
        setLoading(false);
        setOpenChart(true);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
        setLoading(false);
      });
    
    getUnitTrend(date, 'Asin', appContext,
      (response: any) => {
        setAsinUnitTrendData(response.data);
        appContext.setShowLoader(false);
        setLoading(false);
        setOpenChart(true);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
        setLoading(false);
      });
    
    getUnitTrend(date, 'Total', appContext,
      (response: any) => {
        setTotalUnitTrendData(response.data);
        appContext.setShowLoader(false);
        setLoading(false);
        setOpenChart(true);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
        setLoading(false);
      });

    let endDate = date;
    let startDate = dayjs(endDate).subtract(30, 'day').format('YYYY-MM-DD');
    getAdSpendTrend(startDate, endDate, appContext,
      (response: any) => {
        setAdSpendData(response.data);
        appContext.setShowLoader(false);
        setLoading(false);
        setOpenChart(true);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
        setLoading(false);
      });
  }

  const closeChart = (value: any) => {
    setOpenChart(false);
  }

  const onOkClick = () => {
    if('Order' === syncType) {
      syncOrderData(orderDate);
    } else if('Sale' === syncType) {
      syncSaleData(orderDate);
    } else if('Trn' === syncType) {
      syncTrnData(orderDate);
    } else if('Perf' === syncType) {
      syncPerfData(orderDate);
    } else if('All' === syncType) {
      syncAllData(orderDate);
    }
  }

  const syncAllPerfData = () => {
    setLoading(true);
    syncPerfZeroValue(appContext,
      (response: any) => {
        appContext.setShowLoader(false);
        setLoading(false);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
        setLoading(false);
      });
  }

  const syncSaleData = (orderDate: any) => {
    setLoading(true);
    syncSale(orderDate, appContext,
      (response: any) => {
        appContext.setShowLoader(false);
        setLoading(false);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
        setLoading(false);
      });
  }

  const syncTrnData = (orderDate: any) => {
    setLoading(true);
    let date = formatDateTrn(orderDate);
    syncTransactionAPI(date, date, appContext,
      (response: any) => {
        appContext.setShowLoader(false);
        setLoading(false);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
        setLoading(false);
      });
  }

  const syncOrderData = (orderDate: any) => {
    setLoading(true);
    syncOrder(orderDate, appContext,
      (response: any) => {
        appContext.setShowLoader(false);
        setLoading(false);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
        setLoading(false);
      });
  }

  const syncPerfData = (orderDate: any) => {
    setLoading(true);
    syncPerf(orderDate, appContext,
      (response: any) => {
        appContext.setShowLoader(false);
        setLoading(false);
        getOrderData();
        getPerfParamData();
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
        setLoading(false);
      });
  }

  const syncAllData = (orderDate: any) => {
    setLoading(true);
    syncAll(orderDate, appContext,
      (response: any) => {
        appContext.setShowLoader(false);
        setLoading(false);
        getOrderData();
        getPerfParamData();
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
        setLoading(false);
      });
  }

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPeriod((event.target as HTMLInputElement).value);
  }

  function getCurrentTime() {
    return dayjs().tz('America/Los_Angeles').format('hh:mm A');
  }

  const getMainPanel = () => {
    return <>
      <Grid xs={2} sx={{ pl: 2, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <FormControlLabel control={<LocalizationProvider dateAdapter={AdapterDayjs}>
                                      <DatePicker slotProps={{ textField: { size: 'small' } }} format={'DD/MM/YYYY'}  
                                        label={'Start Date'} value={startDate} onChange={startDatechange} timezone="America/Los_Angeles"/>
                                  </LocalizationProvider>} label='' />
        <FormControlLabel control={<LocalizationProvider dateAdapter={AdapterDayjs}> 
                                      <DatePicker slotProps={{ textField: { size: 'small' } }} format={'DD/MM/YYYY'} 
                                        label={'End Date'} value={endDate} onChange={endDatechange} timezone="America/Los_Angeles"/>
                                  </LocalizationProvider>} label='' />
        <FormControl>
          <RadioGroup defaultValue="DailyOrder" name="period" row={true} onChange={handleChange}>
            <FormControlLabel value="DailyOrder" control={<Radio />} label="Daily" />
            <FormControlLabel value="WeeklyOrder" control={<Radio />} label="Weekly" />
            <FormControlLabel value="MonthlyOrder" control={<Radio />} label="Monthly" />
          </RadioGroup>
        </FormControl>
        <IButton label='Submit' onActionEvent={search}/>
      </Grid>
      <Grid xs={12} display="flex" justifyContent="center">
        <Grid container columnSpacing={1} rowSpacing={0} sx={{ maxWidth: '1380px', mt: 2, border: '1px solid #D3D3D3', borderRadius: '4px', p: 2}}>
          <Grid xs={2}>
            <IReadOnlyField label='Days' value={isEmpty(perfParam) ? 'NA' : perfParam.days}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Ads (Adj)' value={isEmpty(perfParam) ? 'NA' : formatTo0Decimal(perfParam.adSpendAdj)}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Daily Ads' value={isEmpty(perfParam) ? 'NA' : formatTo0Decimal(perfParam.dailyAd)}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Order' value={isEmpty(perfParam) ? 'NA' : formatTo0Decimal(perfParam.orderVal)}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Daily Order' value={isEmpty(perfParam) ? 'NA' : formatTo0Decimal(perfParam.dailyOrd)}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Order #' value={isEmpty(perfParam) ? 'NA' : formatTo0Decimal(perfParam.orderCount)}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Daily Order #' value={isEmpty(perfParam) ? 'NA' : formatTo0Decimal(perfParam.dailyOrdCount)}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Total Unit #' value={isEmpty(perfParam) ? 'NA' : formatTo0Decimal(perfParam.orderUnit)}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Daily Unit #' value={isEmpty(perfParam) ? 'NA' : formatTo0Decimal(perfParam.dailyOrdUnit)}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Net Profit' value={isEmpty(perfParam) ? 'NA' : formatTo0Decimal(perfParam.netProfit)}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Daily Net' value={isEmpty(perfParam) ? 'NA' : formatTo0Decimal(perfParam.dailyNet)}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Gross/Order' value={isEmpty(perfParam) ? 'NA' : formatTo1Decimal(perfParam.grossOnSale) + '%'}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Net/Order' value={isEmpty(perfParam) ? 'NA' : formatTo1Decimal(perfParam.netOnSale) + '%'}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Net/LFH Cost' value={isEmpty(perfParam) ? 'NA' : formatTo1Decimal(perfParam.netOnLfhCost) + '%'}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Xneeti/Order' value={isEmpty(perfParam) ? 'NA' : formatTo1Decimal(perfParam.xneetiPct) + '%'}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='ACOS' value={isEmpty(perfParam) ? 'NA' : formatTo1Decimal(perfParam.acos) + '%'}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='TACOS' value={isEmpty(perfParam) ? 'NA' : formatTo1Decimal(perfParam.tacos) + '%'}/>
          </Grid>
          <Grid xs={2}>
            <IReadOnlyField label='Return Rate' value={isEmpty(perfParam) ? 'NA' : formatTo1Decimal(perfParam.returnRate * 100) + '%'}/>
          </Grid>
        </Grid>
      </Grid>
      <IGridComponent title={''} rows={perfData} columns={columns} loading={loading} maxHeight={450}
          showExtBtn={'DailyOrder' === period} extBtnText={'Sync Zero Value'} extBtnAction={syncAllPerfData}
          showExtraText={'DailyOrder' === period} extraText={'Time: ' + getCurrentTime() + 
                                          ' | Ord: ' + (isEmpty(latestOrderTime[0]) ? '' : latestOrderTime[0]) + 
                                          ' | Trn: ' + (isEmpty(latestOrderTime[1]) ? '' : latestOrderTime[1])}
          extraTextColor='blue' showExtBtn2={false} extBtn2Text={'Order Trend'} extBtn2Action={openOrderChart}
          paginationType="server" paginationModelChange={onPaginationModelChange} totalRows={totalRows}
          cellClick={onCellClick} getRowId={(row: any) => row.idDate} cellDoubleClick={onCellDoubleClick}
          showAction={false} showApproveAction={false} showDeleteAction={false} showEditAction={false} />
      <YesNoDialog open={showSyncMsg} onClose={() => { setShowSyncMsg(false) }}
          onOk={() => { setShowSyncMsg(false); onOkClick(); }} isHorizontal={true} 
          message={'Do you want to sync the data?'}/>
      <IDialogComponent onClose={closeValuePopup} open={openValue} title={'Specify Value'}
        dialogBody={<EditCellComponent data={cellValueRow} close={closeValuePopup} label={cellLabel}/>} />
      <IDialogComponent onClose={closeChart} open={openChart} title={'Order Trend: ' + ('ALL' === orderDate ? 'ALL' : formatDate(orderDate))}
        dialogBody={<LineChart data1={orderCountTrendData} data2={orderValueTrendData} data3={asinUnitTrendData}
        data4={totalUnitTrendData} data5={cumulativeTrendData} data6={adSepndData} orderDate={orderDate}/>} />
    </>
  }

  const getMobilePanel = () => {
    const mobileColumns: GridColDef[] = [
    { field: 'syncAll', headerName: 'Sync', filterable: false, sortable: false, editable: false, width: 60, disableColumnMenu: true,
      renderCell: (params) => (<Stack direction="column" alignItems="center" > 
                               <PlayCircleOutline fontSize='small' color="secondary"/> </Stack>)},
    { field: 'period', headerName: 'Date', filterable: false, sortable: false, editable: false, width: 70, disableColumnMenu: true,
      cellClassName: (params) => { return "Tacos2"},
      renderCell: (params) => (formatDateSmall(params.row.orderDate))},
    { field: 'orderVal', headerName: 'Ord', filterable: false, sortable: false, editable: false, width: 65, disableColumnMenu: true,
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePerf(params.row.orderVal)}},
    { field: 'netProfit', headerName: 'Net', filterable: false, sortable: false, editable: false, width: 60, disableColumnMenu: true,
      valueFormatter: (value: any) => getValue0Decimal(value),
      cellClassName: (params) => { return getClassNamePerf(params.row.netProfit) }},
    { field: 'tacos', headerName: 'TACOS', filterable: false, sortable: false, editable: false, width: 70, disableColumnMenu: true,
      cellClassName: (params) => { return getClassNameTacos(params.row.tacos) },
      valueFormatter: (value: any) => 'NA' === getValue1Decimal(value) ? 'NA' : getValue1Decimal(value) + '%'},
    { field: 'adSpend', headerName: 'Ads', filterable: false, sortable: false, editable: false, width: 65, disableColumnMenu: true,
      valueFormatter: (value: any) => getValue0Decimal(value)},
    ];
    return <>
    <Box sx={{ fontSize: '20px', fontWeight: 'bold', color: 'darkblue' }}>DAILY ORDER</Box>
    <IGridComponent title={''} rows={perfData} columns={mobileColumns} loading={loading} maxHeight={450}
          showExtraText={'DailyOrder' === period} extraText={'Time: ' + getCurrentTime() + 
                                          ' | Ord: ' + (isEmpty(latestOrderTime[0]) ? '' : latestOrderTime[0]) + 
                                          ' | Trn: ' + (isEmpty(latestOrderTime[1]) ? '' : latestOrderTime[1])}
          cellClick={onCellClick} getRowId={(row: any) => row.idDate} extraTextColor='blue'
          showAction={false} hideFooter={true} />
      <YesNoDialog open={showSyncMsg} onClose={() => { setShowSyncMsg(false) }}
          onOk={() => { setShowSyncMsg(false); onOkClick(); }} isHorizontal={true} 
          message={'Do you want to sync the data?'}/>
      <IDialogComponent onClose={closeValuePopup} open={openValue} title={'Specify Value'}
        dialogBody={<EditCellComponent data={cellValueRow} close={closeValuePopup} label={cellLabel}/>} />
    </>
  }

  return  !isMobile ? <TitlePanel title={(period.includes('Monthly') ? 'Monthly' : period.includes('Daily') ? 'Daily' : 'Weekly') + ' Order'} 
          panelBody={getMainPanel()}/> : getMobilePanel();
}

export default AmazonOrderPerf;